import { ACADEMY_MENU_ROUTES } from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-menu-routes.const'

export const ACADEMY_BASE_URL = process.env.NEXT_PUBLIC_WEB_ACADEMY_URL || ''

export const ACADEMY_ROUTES = {
  ...ACADEMY_MENU_ROUTES,
  courses: '/courses',
  codeSamples: '/code-samples',
  support: '/support',
  events: '/events',
  forum: '/forum',
} as const

export function buildDocumentationHref(slug: string): string {
  return slug ? `${ACADEMY_ROUTES.documentation}/${slug}` : ACADEMY_ROUTES.documentation
}

export const SECTION_REDIRECT_RULES = [
  { path: ACADEMY_ROUTES.documentation, stripPrefix: /^docs\// },
  { path: ACADEMY_ROUTES.quickStart },
] as const
